import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import LinearProgressWithLabel from './LinearProgressWithLabel';
import playerStore from '../../stores/player';
import performanceStore from '../../stores/performance';

function PerformanceListItemTime(props) {

  const countdown = performanceStore((state) => state.countdown);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const currentTime = playerStore((state) => state.currentTime);

  const getCountdownMinutes = () => {
    if (!nextPerformance) {
      if (props.index == 0) {
        return 0;
      } else {
        return props.performance.incoming + ((props.index) * props.autoPlaySecs) - currentTime;
      }
    } else {
      if (props.index == 0) {
        return countdown;
      } else {
        return props.performance.incoming + (props.index * props.autoPlaySecs) + countdown - currentTime;
      }
    }
  };

  const toMinutes = (secs) => {
    var sec_num = parseInt(secs, 10);
    var minutes = Math.floor(sec_num / 60);
    return minutes;
  };

  const fromNowToMinutes = (secs) => {
    let timeObject = new Date();
    const milliseconds = secs * 1000;
    timeObject = new Date(timeObject.getTime() + milliseconds);
    return timeObject.getHours() + ":" + (timeObject.getMinutes() < 10 ? "0" + timeObject.getMinutes() : timeObject.getMinutes());
  };

  return (
    <div>
      <span className="muvika-performance-list-item-minutes">{toMinutes(getCountdownMinutes()) + " min"}</span> <span className="muvika-performance-list-item-minutes"><AccessTimeIcon className="muvika-access-time-icon" /> {fromNowToMinutes(getCountdownMinutes())}</span>
    </div>
  );
}

export default PerformanceListItemTime;